<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md10 sm11>
          <h3 class="text-center">Patient Tests</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" :disabled="patient_tests.length < 1" :append-icon="filterBy.length > 0 ? 'close' : ''" @click:append="() => (filterBy = '')"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn small color="primary" outlined @click="goTo(create_link)" v-if="canCreate">
                Create New
              </v-btn>
            </v-card-title>
            <v-card-text>
              <patient-tests-table :tests="patient_tests" :filterBy="filterBy"></patient-tests-table>
            </v-card-text>
            <v-card-actions>
              <p>This page only show Lab Tests requested via the Service Request.</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const PatientTestsTable =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/index')

  export default {
    name: 'PatientTests',
    layout,
    props: [
      'patient_tests', 'canCreate', 'create_link'
    ],
    components: {
      PatientTestsTable,
    },
    metaInfo () {
      return {
        title: 'Patient Tests',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
      }
    },
  }
</script>
